export default __webpack_public_path__ + "staticlp1/media/banner-home-1024x768.a20696df.png";